export default __webpack_public_path__ + "static/media/442.7c7ec98c.jpg";